module.exports = __webpack_public_path__ + "img/notify_warning.d98b04da.svg";